/**
 * Created by ma.rongqin on 2016/2/22.
 */
'use strict';
angular.module('editingCenterPersonalPreviewModule', [])
    .config(['$stateProvider', function ($stateProvider) {
        $stateProvider
            .state('editingCenterPersonalVersionTime', {
                url: '/editingcenterpersonalversiontime?objectversionid',
                views: {
                    '': {
                        templateUrl: './editingCenter/service/versionTime/personalVersionTime/personalVersionTime.html',
                        controller: 'editCenPersonalVersionTimeCtrl'
                    }
                }
            })
            .state('editingCenterWeixinPersonalVersionTime', {
                url: '/editingcenterweixinpersonalversiontime?wxobjectversionid',
                views: {
                    '': {
                        templateUrl: './editingCenter/service/versionTime/personalVersionTime/weixinPersonalVersionTime_tpl.html',
                        controller: 'editCenWeixinPersonalVersionTimeCtrl'
                    }
                }
            })
            .state('editingCenterIwoPersonalVersionTime', {
                url: '/editingcenteriwopersonalversiontime?iwoobjectversionid',
                views: {
                    '': {
                        templateUrl: './editingCenter/service/versionTime/personalVersionTime/iwoPersonalVersionTime_tpl.html',
                        controller: 'editCenIwoPersonalVersionTimeCtrl'
                    }
                }
            })
            .state('editingCenterAppPersonalVersionTime', {
                url: '/editingcenterapppersonalversiontime?appobjectversionid',
                views: {
                    '': {
                        templateUrl: './editingCenter/service/versionTime/personalVersionTime/appPersonalVersionTime_tpl.html',
                        controller: 'editCenAppPersonalVersionTimeCtrl'
                    }
                }
            })
            .state('editingCenterWebsitePersonalVersionTime', {
                url: '/editingcenterwebsitepersonalversiontime?wzobjectversionid',
                views: {
                    '': {
                        templateUrl: './editingCenter/service/versionTime/personalVersionTime/websitePersonalVersionTime_tpl.html',
                        controller: 'editCenWebsitePersonalVersionTimeCtrl'
                    }
                }
            })
            .state('editingCenterPaperPersonalVersionTime', {
                url: '/editingcenterpaperpersonalversiontime?bzobjectversionid',
                views: {
                    '': {
                        templateUrl: './editingCenter/service/versionTime/personalVersionTime/paperPersonalVersionTime_tpl.html',
                        controller: 'editCenPaperPersonalVersionTimeCtrl'
                    }
                }
            })
            .state('editingCenterFusionPersonalVersionTime', {
                url: '/editingCenterFusionPersonalVersionTime?metadataid&iwoobjectversionid&appobjectversionid&wzobjectversionid&bzobjectversionid&wxobjectversionid&versionum',
                views: {
                    '': {
                        templateUrl: './editingCenter/service/versionTime/personalVersionTime/fusionVersionTime/fusionVersionTime.html',
                        controller: 'fusionVersionTimeCtrl'
                    }
                }
            })
            .state('editingCenterTelevisionPersonalVersionTime', {
                url: '/editingcentelevisionpersonalversiontime?tvobjectversionid',
                views: {
                    '': {
                        templateUrl: './editingCenter/service/versionTime/personalVersionTime/televisionPersonalVersionTime_tpl.html',
                        controller: 'editCenTelevisionPersonalVersionTimeCtrl'
                    }
                }
            })
            .state('editingCenterBroadcastPersonalVersionTime', {
                url: '/editingcenbroadcastpersonalversiontime?bcobjectversionid',
                views: {
                    '': {
                        templateUrl: './editingCenter/service/versionTime/personalVersionTime/broadcastPersonalVersionTime_tpl.html',
                        controller: 'editCenBroadcastPersonalVersionTimeCtrl'
                    }
                }
            })
            .state('viewtraces', {
                url: '/viewtraces?docversionid&mediatype',
                views: {
                    '': {
                        templateUrl: './editingCenter/service/versionTime/viewTraces/viewTraces.html',
                        controller: 'viewTracesCtrl'
                    }
                }
            });
    }]);
